export const isEditMode = (): boolean => {
    return !!document.querySelector('html')?.classList.contains('editMode');
}
